import * as types from '../../mutation_types';
import {https,httpsFile} from './http';
import { downloadExport } from './inventories';

const state = {
    rangeshow:false,
    specificshow:false,
    loading:false,
    page:1,
    currentpage:5,
    data:{},
    materials:[],
    materialfrom:'',
    materialto:'',
    materialgroupfrom:'',
    materialgroupto:'',
    materialgroup1from:'',
    materialgroup1to:'',
    materialgroup3from:'',
    materialgroup3to:'',
    materialgroup5from:'',
    materialgroup5to:'',
    materialgroup5:[],
    materialgroup3:[],
    materialgroup1:[],
    materialgroups:[],
    date_range_selected:{},
    vendorfrom:'',
    vendorto:''
};
const getters = {
    rangeshow:state=>state.rangeshow,
    specificshow:state=>state.specificshow,
    loading:state=>state.loading,
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    data:state=>state.data,
    materialgroup1:state=>state.materialgroup1,
    materialgroup3:state=>state.materialgroup3,
    materialgroup5:state=>state.materialgroup5,
    materialgroups:state=>state.materialgroups,
    materials:state=>state.materials,
    materialfrom:state=>state.materialfrom,
    materialto:state=>state.materialto,
    materialgroupfrom:state=>state.materialgroupfrom,
    materialgroupto:state=>state.materialgroupto,
    materialgroup1from:state=>state.materialgroup1from,
    materialgroup1to:state=>state.mateiralgroup1to,
    materialgroup3from:state=>state.materialgroup3from,
    materialgroup3to:state=>state.mateiralgroup3to,
    materialgroup5from:state=>state.materialgroup5from,
    materialgroup5to:state=>state.mateiralgroup5to,
    vendorfrom:state=>state.vendorfrom,
    vendorto:state=>state.vendorto
};
const actions = {
    async fetchMaterialgroup5({commit}){
        let uri = `material-group5`;
        await https( ).get(uri).then((response)=>{
            commit(types.MO_MATERIALGROUP5,response.data);
        }).catch((error)=>{
            console.log(error);
        })
    },
    async fetchMaterialgroup3({commit}){
        let uri = `material-group3`;
        await https( ).get(uri).then((response)=>{
            commit(types.MO_MATERIALGROUP3,response.data);
        }).catch((error)=>{
            console.log(error);
        })
    },
    async fetchMaterialgroup1({commit}){
        let uri = `material-group1`;
        await https( ).get(uri).then((response)=>{
            commit(types.MO_MATERIALGROUP1,response.data);
        }).catch((error)=>{
            console.log(error);
        })
    },
    async fetchMaterialgroups({commit}){
        let uri = `material-group`;
        await https( ).get(uri).then((response)=>{
            commit(types.MO_MATERIALGROUPS,response.data);
        }).catch((error)=>{
            console.log(error);
        })
    },
    async fetchOfftakes({commit}){
        commit(types.MO_LOADING,true);
        let materials = [];
        if(state.materials.length!==0){
            $.each(state.materials,(key,value)=>{
                let matnr = value.matnr;
                materials.push(matnr);
            })
        }
        let uri = `offtakes?page=${state.page}&currentpage=${state.currentpage}&vendor_from=${state.vendorfrom}&vendor_to=${state.vendorto}
        &material_group1_from=${state.materialgroup1from}&material_group1_to=${state.materialgroup1to}
        &material_group3_from=${state.materialgroup3from}&material_group3_to=${state.materialgroup3to}
        &material_group5_from=${state.materialgroup5from}&material_group5_to=${state.materialgroup5to}
        &material_group_from=${state.materialgroupfrom}&material_group_to=${state.materialgroupto}
        &material_from=${state.materialfrom}&material_to=${state.materialto}&materials=${materials}`;
        await https( ).get(uri).then((response)=>{
            commit(types.MO_DATA,response.data);
            commit(types.MO_LOADING,false);
        }).catch((error)=>{
            console.log(error);
        })
    },
    async fetchDynamicOfftakes({commit}){
        commit(types.MO_LOADING,true);
        let materials = [];
        if(state.materials.length!==0){
            $.each(state.materials,(key,value)=>{
                let matnr = value.matnr;
                materials.push(matnr);
            })
        }
        let uri = `showDynamicOfftakes?page=${state.page}&currentpage=${state.currentpage}&vendor_from=${state.vendorfrom}&vendor_to=${state.vendorto}
        &material_group1_from=${state.materialgroup1from}&material_group1_to=${state.materialgroup1to}
        &material_group3_from=${state.materialgroup3from}&material_group3_to=${state.materialgroup3to}
        &material_group5_from=${state.materialgroup5from}&material_group5_to=${state.materialgroup5to}
        &material_group_from=${state.materialgroupfrom}&material_group_to=${state.materialgroupto}
        &material_from=${state.materialfrom}&material_to=${state.materialto}&materials=${materials}
        &date_range_selected=${JSON.stringify(state.date_range_selected)}`;
        await https( ).get(uri).then((response)=>{
            commit(types.MO_DATA,response.data);
            commit(types.MO_LOADING,false);
        }).catch((error)=>{
            console.log(error);
        })
    },
    async export({commit}){
        let materials = [];
        if(state.materials.length!==0){
            $.each(state.materials,(key,value)=>{
                let matnr = value.matnr;
                materials.push(matnr);
            })
        }
       let uri = `offtakes/create?page=${state.page}&currentpage=-1&vendor_from=${state.vendorfrom}&vendor_to=${state.vendorto}&material_group1_from=${state.materialgroup1from}&material_group1_to=${state.materialgroup1to}&material_group_from=${state.materialgroupfrom}&material_group_to=${state.materialgroupto}&material_from=${state.materialfrom}&material_to=${state.materialto}&materials=${materials}`;
       await httpsFile( ).get(uri).then(async(result)=>{
            let file_name = result.data.split('/')[2];
            let excel_uri = `downloads?file_path=${result.data}`;
            await https().get(excel_uri, { responseType: "blob" }).then((response)=>{
                let file_url = window.URL.createObjectURL(new Blob([response.data]));
                let file_link = document.createElement('a');
                file_link.href = file_url;
                file_link.setAttribute('download',file_name);
                document.body.appendChild(file_link);
                file_link.click();
            })
       })
    },
    async exportDynamicOfftakes({commit}){
        let materials = [];
        if(state.materials.length!==0){
            $.each(state.materials,(key,value)=>{
                let matnr = value.matnr;
                materials.push(matnr);
            })
        }
       let uri = `exportDynamicOfftakes?page=${state.page}&currentpage=-1&vendor_from=${state.vendorfrom}&vendor_to=${state.vendorto}
       &material_group1_from=${state.materialgroup1from}&material_group1_to=${state.materialgroup1to}
       &material_group_from=${state.materialgroupfrom}&material_group_to=${state.materialgroupto}
       &material_from=${state.materialfrom}&material_to=${state.materialto}&materials=${materials}
       &date_range_selected=${JSON.stringify(state.date_range_selected)}`;
       await httpsFile( ).get(uri).then(async(result)=>{
            let file_name = result.data.split('/')[2];
            let excel_uri = `downloads?file_path=${result.data}`;
            await https().get(excel_uri, { responseType: "blob" }).then((response)=>{
                let file_url = window.URL.createObjectURL(new Blob([response.data]));
                let file_link = document.createElement('a');
                file_link.href = file_url;
                file_link.setAttribute('download',file_name);
                document.body.appendChild(file_link);
                file_link.click();
            })
       })
    },
};
const mutations = {
    [types.MO_LOADING](state,data){
        state.loading = data;
    },
    [types.MO_PAGE](state,data){
        state.page = data;
    },
    [types.MO_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.MO_DATA](state,data){
        state.data = data;
    },
    [types.MO_MATERIALS](state,data){
        let matnr = data.matnr;
        let index = state.materials.findIndex((details)=>details.matnr === matnr);
        if(index !== -1){
            state.materials.splice(index,1);
        }else{
            state.materials.push(data);
        }
    },
    [types.MO_MATERIALFROM](state,data){
        state.materialfrom = data;
    },
    [types.MO_MATERIALTO](state,data){
        state.materialto = data;
    },
    [types.MO_MATERIALGROUPFROM](state,data){
        state.materialgroupfrom = data;
    },
    [types.MO_MATERIALGROUPTO](state,data){
        state.materialgroupto = data;
    },
    [types.MO_MATERIALGROUP5FROM](state,data){
        state.materialgroup5from = data;
    },
    [types.MO_MATERIALGROUP5TO](state,data){
        state.materialgroup5to = data;
    },
    [types.MO_DATERANGESELECTED](state,data){
        state.date_range_selected = data;
    },
    [types.MO_MATERIALGROUP3FROM](state,data){
        state.materialgroup3from = data;
    },
    [types.MO_MATERIALGROUP3TO](state,data){
        state.materialgroup3to = data;
    },
    [types.MO_MATERIALGROUP1FROM](state,data){
        state.materialgroup1from = data;
    },
    [types.MO_MATERIALGROUP1TO](state,data){
        state.materialgroup1to = data;
    },
    [types.MO_MATERIALGROUP5](state,data){
        state.materialgroup5 = data;
    },
    [types.MO_MATERIALGROUP3](state,data){
        state.materialgroup3 = data;
    },
    [types.MO_MATERIALGROUP1](state,data){
        state.materialgroup1 = data;
    },
    [types.MO_MATERIALGROUPS](state,data){
        state.materialgroups = data;
    },
    [types.MO_VENDORFROM](state,data){
        state.vendorfrom = data;
    },
    [types.MO_VENDORTO](state,data){
        state.vendorto = data;
    },
    [types.MO_SPECIFICSHOW](state){
        state.specificshow = !state.specificshow;
    },
    [types.MO_RANGESHOW](state){
        state.rangeshow = !state.rangeshow;
    },
    [types.MO_CLEAR](state){
        state.page=1;
        state.currentpage=5;
        state.data={};
        state.materials=[];
        state.materialfrom='';
        state.materialto='';
        state.materialgroupfrom='';
        state.materialgroupto='';
        state.materialgroup1from='';
        state.materialgroup1to='';
        state.materialgroup3from='';
        state.materialgroup3to='';
        state.materialgroup5from='';
        state.materialgroup5to='';
        state.vendorfrom='';
        state.vendorto='';
    }
};

export {
    state,getters,actions,mutations
}